CarouselVue(data-test='carousel' :total='items.length' @index-updated='index => setCurrentIndex(index.value)')
  .fp-slider--image(v-for='(item, index) in items' :key='index' :class='{"-active": index === currentIndex}' :data-test='`carousel.image-${index}`')
    router-link.fp-link.-no-text-decoration(:to='item.route' :id='item.id')
      PresentationCardVue(:item='item')
